import React from 'react';
import s from './styles.module.scss';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@mui/material';
import { ChevronRightRounded } from '@mui/icons-material';
import classNames from 'classnames';

interface IExpansionPanelAccordionProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

const ExpansionPanelAccordion: React.FC<IExpansionPanelAccordionProps> = (
  props
) => {
  const { children, title, className = '' } = props;

  const expansionPanelAccordionClassNames = classNames(
    s['accordion'],
    className
  );

  return (
    <Accordion
      className={expansionPanelAccordionClassNames}
      disableGutters
      elevation={0}
      square
      sx={{
        backgroundColor: 'transparent',
        backgroundImage: 'none',
        boxShadow: 'none',
        border: 'none',
        '&::before': {
          display: 'none',
        },
        '&.Mui-expanded': {
          margin: 0,
        },
      }}
    >
      <AccordionSummary
        className={s['accordion-summary']}
        aria-controls={title}
        id={title}
        expandIcon={
          <ChevronRightRounded fontSize="small" className={s['icon']} />
        }
        sx={{
          color: 'var(--text-color)',
          minHeight: 48,
          padding: '0 0 0 10px',
          '&.Mui-expanded': {
            minHeight: 48,
          },
          '& .MuiAccordionSummary-content': {
            margin: '12px 0',
          },
          '& .MuiAccordionSummary-content.Mui-expanded': {
            margin: '12px 0',
          },
          '& .MuiAccordionSummary-expandIconWrapper': {
            color: '#808085',
          },
        }}
      >
        <Typography>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails
        className={s['accordion-details']}
        sx={{ padding: '0 0 0 10px' }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default ExpansionPanelAccordion;
